import React, { useState, useEffect } from 'react';
import Carousel from './home/carousel'; 
import Course from './home/course';
import News from './home/news'; 
import Contact from './home/contact';
import Advice from './home/advice';
import { useLocation } from 'react-router-dom';
import { getNews, getCourses, getCarousel } from '../api/service';
import WhatsAppWidget from './home/WhatsAppWidget';

function Home({ configData }) { 
    const [newsData, setNewsData] = useState([]);
    const [courseData, setCourseData] = useState([]);
    const [carouselData, setCarouselData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const location = useLocation();

    useEffect(() => {
        const loadData = async () => {
            setIsLoading(true);

            // 1. Cargamos Noticias de forma independiente
            try {
                const news = await getNews();
                setNewsData(news);
            } catch (error) {
                console.error("Error cargando noticias", error);
            }

            // 2. Cargamos Cursos de forma independiente
            try {
                const courses = await getCourses();
                setCourseData(courses);
            } catch (error) {
                console.error("Error cargando cursos", error);
                setCourseData([]);
            }

            // 3. Cargamos Carrusel de forma independiente
            try {
                const carousel = await getCarousel();
                setCarouselData(carousel); 
            } catch (error) {
                console.error("Error cargando carrusel", error);
            }

            // Terminamos la carga pase lo que pase
            setTimeout(() => setIsLoading(false), 1000);
        };
        
        loadData();
    }, []);
    

    useEffect(() => {
        if (location.hash) {
            const targetElement = document.getElementById(location.hash.substring(1));
            
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: "smooth" });
            }
        }
    }, [location]);

    return (
        <main>
            <section id="carrusel">
                <Carousel carouselData={carouselData} isLoading={isLoading}/>
            </section>

            <section id="cursos">
                <Course courseData={(courseData || []).slice(0, 4)} isLoading={isLoading} limitHome />
            </section>

            <section id="noticias">
                <News newsData={(newsData || []).slice(0, 4)} isLoading={isLoading} limitHome />
            </section>

            

            <section id="asesorias">
                <Advice configData={configData} isLoading={isLoading}/>
            </section>
            
            <section id="contacto">
                <Contact configData={configData} isLoading={isLoading}/>
            </section>
            
            <WhatsAppWidget />
        </main>
    );
}

export default Home;